/*
 * The copilot's one logger (the helper's 10-13 ruling, L12 and L13). Every
 * log line in features/copilot goes through here, and nothing else in the
 * feature touches the console (__tests__/copilotLogging.test.js).
 *
 * - It logs a fixed string and the error's code only: never the error, its
 *   message or its details, which can carry tool arguments, the user's text
 *   or customer names. A code that isn't a short word logs as "unknown".
 * - It never throws. A thrown null, a string, an object whose `code` getter
 *   throws, a Proxy or a console that throws all end here, and a logger that
 *   threw from a .catch would turn into the unhandled rejection that makes
 *   index.js replace the app.
 *
 * In domain/ so the presentational components (ApprovalCard, Composer) can
 * share it: the props-only guard bans their importing anything from hooks/.
 */

const CODE_PATTERN = /^[A-Za-z0-9_.:-]{1,64}$/;
const FALLBACK_MESSAGE = "[copilot] failed";

/** The error's `code` when it's a short word, else "unknown". Never throws. */
export function errorCodeOf(err) {
  try {
    if (err === null || (typeof err !== "object" && typeof err !== "function")) return "unknown";
    const { code } = err;
    return typeof code === "string" && CODE_PATTERN.test(code) ? code : "unknown";
  } catch (e) {
    return "unknown";
  }
}

function write(level, message, err, hasError) {
  try {
    const text = typeof message === "string" ? message : FALLBACK_MESSAGE;
    const args = hasError ? [text, errorCodeOf(err)] : [text];
    /* eslint-disable no-console */
    if (level === "warn") console.warn(...args);
    else console.error(...args);
    /* eslint-enable no-console */
  } catch (e) {
    // Logging never throws (L12).
  }
}

/**
 * console.error(message, code). `message` is a fixed string at the call
 * site, such as "[copilot] ApprovalCard onDecide failed".
 */
export function logCopilotError(message, ...error) {
  write("error", message, error[0], error.length > 0);
}

/** console.warn(message, code), or console.warn(message) with no error. */
export function logCopilotWarning(message, ...error) {
  write("warn", message, error[0], error.length > 0);
}
